/**
 * intentLabels — human-readable labels for chat routed intents.
 *
 * Single source of truth for every surface that displays the intent
 * classified at chat submit: the user-message chip (MessageBubble),
 * the streaming status line (CommandRail via buildStreamingStatus),
 * the chat-run-activity bubble (VariantCShell), and the edit-proposal
 * message. Pure module — no React, no I/O.
 */

import type { ChatRoutedIntent } from "../api/client";

const LABELS: Record<ChatRoutedIntent, string> = {
  chat: "Chat",
  edit_section: "Edit section",
  draft_content: "Draft content",
  edit_highlight: "Edit highlight",
  research_highlight: "Research",
};

export function intentLabel(intent: ChatRoutedIntent): string {
  // Stale persisted intents (e.g. the retired "regen_section") fall
  // back to the default label — old history renders harmlessly.
  return LABELS[intent] ?? "Chat";
}
